export default __webpack_public_path__ + "3fe68428516ec07d214c3a4e4a6dd54b.svg";